import React, { useContext, useState, useEffect } from 'react';
import Table from 'antd/lib/table';
import Column from 'antd/lib/table/Column';
import { PaymentDetailsContext } from './PaymentDetailsForm';
import { ModelContext } from '../../metadata/ModelSource';
import { FormContext } from '../../metadata/MDForm';
import { GlobalStateContext } from '../../../context/GlobalStateProvider';
import { PaymentMobileTable } from '../../layout/PaymentMobileTable';
import {DownOutlined, RightOutlined} from "@ant-design/icons";

export const PaymentPlans = ({ columns, filterExclude}) => {
  let { paymentPlans, setDownPaymentAmt } = useContext(PaymentDetailsContext);
  paymentPlans = paymentPlans.filter(plan=>filterExclude && !filterExclude.payerType.includes(plan.payerType));

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { changePaymentPlansToMobile } = useContext(GlobalStateContext);

  const applicationModel = useContext(ModelContext);
  const form = useContext(FormContext);
  const path = 'basicPolicy.payPlanCd';

  useEffect(() => {
    const previousValue = applicationModel.getValue(path);
    if (previousValue) {
      const foundPlan = paymentPlans.filter((plan) => {
        return plan.payPlanCd === previousValue;
      });
    }
  }, []);

  const groupAllPlans = (allCurrentPlans, property) => {
    const allPlansObject = allCurrentPlans.reduce((plans, currentPlan) => {
      if (!plans[currentPlan[property]]) {
        plans[currentPlan[property]] = [];
      }
      plans[currentPlan[property]].push(currentPlan);
      return plans;
    }, []);

    const titles = Object.keys(allPlansObject);
    const allPlans = Object.values(allPlansObject);

    return {
      titles,
      allPlans,
    };
  };

  const groupedPlans = groupAllPlans(paymentPlans, 'type');

  const onTableRowExpand = (expanded, row) => {
    const payPlanCd = row.payPlanCd;
    const downPaymentAmt = row.downPaymentAmt;

    selectPayPlan(expanded, payPlanCd, downPaymentAmt);
  };

  const rowSelection = {
    type: 'radio',
    selectedRowKeys: selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      const payPlanCd = selectedRowKeys[0];
      const downPaymentAmt = selectedRows[0].downPaymentAmt;

      selectPayPlan(true, payPlanCd, downPaymentAmt);
    }
  };

  const selectPayPlan = (expanded, payPlanCd, downPaymentAmt) => {
    let container = applicationModel.getValue(path);
    if (container == undefined) {
      container = payPlanCd;
      form.setValue(path, container);
    }

    form.setValue(path, payPlanCd);
    form.setValueByAttr('DownPayment', downPaymentAmt);
    let keys = [];
    if (expanded) {
      keys.push(payPlanCd);
    }

    setSelectedRowKeys(keys);
  };

  const { allPlans, titles } = groupedPlans;

  if (changePaymentPlansToMobile) {
    return (
      <PaymentMobileTable
        allPlans={allPlans}
        titles={titles}
        columns={columns}
        onTableRowExpand={onTableRowExpand}
        selectedRowKeys={selectedRowKeys}
      />
    );
  }

  return (
    <div>
      {allPlans.map((rowData, index) => {
        const title = titles[index];

        return (
          <div key={index}>
            <div style={{ marginTop: index !== 0 ? '30px' : '' }}>
              <h3>{title}</h3>
            </div>
            <Table
              rowSelection={rowSelection}
              onHeaderRow={(column, index) => {
                return {
                  className: 'ant-hide-expand-icon-th',
                };
              }}
              dataSource={rowData}
              rowKey={(data) => data.payPlanCd}
              size="small"
              pagination={false}
              bordered={false}
              expandIcon={() => null}
              expandedRowKeys={selectedRowKeys}
              expandedRowRender={(row, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      ...styles.container,
                    }}
                  >
                    <div
                      style={{
                        ...styles.col(12),
                      }}
                    >
                      # of Installments {row.numberOfInstallments}
                    </div>
                    <div
                      style={{
                        ...styles.col(12),
                      }}
                    >
                      Total # of Payments {row.numberOfPayments}
                    </div>
                  </div>
                );
              }}
              onRow={(row) => ({
                onClick: () => {
                  onTableRowExpand(true, row);
                },
              })}
            >
              <Column
                dataIndex="selected"
                key="selected"
                onCell={(record, rowIndex) => {
                  return {
                    width: '50px',
                  };
                }}
                render={(value, row, index) => {
                  const { payPlanCd } = row;
                  return (
                    <div style={{ width: '45px' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                      { selectedRowKeys && selectedRowKeys === payPlanCd ? <DownOutlined /> : <RightOutlined /> }
                      </div>
                    </div>
                  );
                }}
              />
              {columns.map((column, index) => {
                return (
                  <Column
                    title={column.title}
                    dataIndex={column.dataIndex}
                    key={column.key}
                    align={index !== 0 ? 'right' : ''}
                  />
                );
              })}
            </Table>
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flex: 24,
  },
  col: (span) => ({
    flex: span,
    textAlign: 'left',
  }),
};
